import classNames from 'classnames';
import React from 'react';
import { mapSemestersToModel } from '~/Pages/CampusStudyPage/View/Utils/StudyModelUtils';
import type { LegacyStudyModelViewModel } from '~/Pages/CampusStudyPage/ViewModel/StudyModel/LegacyStudyModelViewModel.csharp';
import { Link } from '~/Partials/Link/Link';
import { LinkVariant } from '~/Partials/Link/LinkVariant.csharp';
import { List } from '~/Partials/List/List';
import { StudySubjects } from '~/Partials/StudySubjects/StudySubjects';
import styles from './StudyModelSectionAccordionItemContent.module.css';

interface StudyModelSectionAccordionItemContentProps {
    heading: string;
    prerequisitesHeading: string;
    data: LegacyStudyModelViewModel;
    className?: string;
}

export const StudyModelSectionAccordionItemContent: React.FC<StudyModelSectionAccordionItemContentProps> = props => {
    const { heading, prerequisitesHeading, data, className } = props;

    const renderPrerequisites = () => {
        if (data.prerequisites.subjects.length <= 0) {
            return null;
        }

        const { subjects } = data.prerequisites;

        return (
            <div className={styles.PrerequisitesContainer}>
                <h3 className={styles.PrerequisitesHeading}>{prerequisitesHeading}</h3>
                <List
                    className={styles.Prerequisites}
                    items={subjects}
                    renderItem={prerequisite => {
                        const { url, name } = prerequisite;

                        return (
                            <li className={styles.Prerequisite} key={name}>
                                {url ? (
                                    <Link variant={LinkVariant.LightBlack} href={url} label={name} />
                                ) : (
                                    <span>{name}</span>
                                )}
                            </li>
                        );
                    }}
                />
            </div>
        );
    };

    return (
        <div className={classNames(styles.AccordionItemContent, className)}>
            <p className={styles.Heading}>{heading}</p>
            {renderPrerequisites()}
            <StudySubjects programSemesters={mapSemestersToModel(data.semesters)} />
        </div>
    );
};
